import React from "react";
import { useNavigate } from "react-router-dom";
import { formatTime, formatDate } from "./utils";
import { getNotificationRoute, isNotificationRoutable, getNotificationAction, getNotificationTypeLabel, extractRelatedIds } from "./notificationRoutes";

const NotificationItem = ({ notification, onMarkAsRead }) => {
  const navigate = useNavigate();
  const { message, createdAt, isRead, type } = notification;
  const isUnread = !isRead;
  
  const relatedIds = extractRelatedIds(notification);
  const { stockRegisterId, labSetupId } = relatedIds;

  const navPath = getNotificationRoute(type, relatedIds);
  const isClickable = isNotificationRoutable(type) && !!labSetupId && (type === 'EXPIRY' || !!stockRegisterId);
  const notificationAction = getNotificationAction(type);
  
  const handleClick = () => {
   
    if (isUnread && onMarkAsRead) {
      onMarkAsRead(notification.id);
    }
    
    if (navPath) {
      navigate(navPath);
    }
  };
  
  return (
    <div
      onClick={handleClick}
      style={{
        padding: "2px 6px",
        borderBottom: "1px solid #d1d1d1",
        cursor: isClickable ? "pointer" : "default",
        backgroundColor: "white",
        opacity: isClickable ? 1 : 0.7,
      }}
      title={isClickable ? `Click to view ${getNotificationTypeLabel(type).toLowerCase()} details` : 'No details available'}
    >
      <div
        style={{
          fontSize: 11,
          color: "#999999",
          marginTop: 6,
          marginBottom: 2,
          fontFamily: "'poppins', Arial",
        }}
      >
        {/* {formatDate(createdAt, "DD MMMM YYYY")}  */}
        {formatTime(createdAt)}
      </div>
      <div
        style={{
          fontSize: 11,
          color: isClickable ? "#101820" : "#666666",
          lineHeight: 1.5,
          wordBreak: "break-word",
          fontFamily: "'poppins', Arial",
          fontWeight: isUnread ? 600 : 400,
          textDecoration: "none",
        }}
      >
        {message}
      </div>
    </div>
  );
};

export default NotificationItem;